module.exports = __webpack_public_path__ + "static/media/rede-protecao-9.fc3b1d84.jpeg";